__turbopack_context__.v({
  "action": "Guarantees-module-scss-module__2senlG__action",
  "box": "Guarantees-module-scss-module__2senlG__box",
  "content": "Guarantees-module-scss-module__2senlG__content",
  "description": "Guarantees-module-scss-module__2senlG__description",
  "fade-in": "Guarantees-module-scss-module__2senlG__fade-in",
  "heading": "Guarantees-module-scss-module__2senlG__heading",
  "logo": "Guarantees-module-scss-module__2senlG__logo",
  "modalContent": "Guarantees-module-scss-module__2senlG__modalContent",
  "modalImage": "Guarantees-module-scss-module__2senlG__modalImage",
  "no-transform": "Guarantees-module-scss-module__2senlG__no-transform",
  "rotate": "Guarantees-module-scss-module__2senlG__rotate",
});
